var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zn-container"},[_c('Sidebar'),_c('router-view'),_c('SizeLimit'),_c('Confirm'),_c('Alert'),_c('Snackbar'),_c('Prompt')],1)}
var staticRenderFns = []

export { render, staticRenderFns }